import React, { useState } from 'react';
import './styles.scss';

const ImageModal = ({ src, alt }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleImageClick = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleMouseMove = (e) => {
        const image = e.target;
        const { left, top, width, height } = image.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;
        image.style.transformOrigin = `${x}% ${y}%`;
    };

    return (
        <div>
            <img
                src={src}
                alt={alt}
                onClick={handleImageClick}
                className="thumbnail"
            />
            {isOpen && (
                <div className="modal-overlay" onClick={handleClose}>
                    <div className="modal-content">
                        <img
                            src={src}
                            alt={alt}
                            className="modal-image"
                            onMouseMove={handleMouseMove}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ImageModal;
